import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { BRAND } from "../../data/content";
import { CATEGORIES } from "../../data/products";
import { SOCIAL_LINKS } from "../../data/social";
import { fetchSocialLinks } from "../../services/api";

const COLUMNS = [
  {
    title: "Shop",
    links: CATEGORIES.map((c) => ({ label: c.label.replace(" Bracelets", ""), to: `/shop?category=${c.id}` })),
  },
  {
    title: "The House",
    links: [
      { label: "Our Story", to: "/#our-story" },
      { label: "Explore Bracelets", to: "/#collections" },
      { label: "New Arrivals", to: "/#new-arrivals" },
      { label: "Best Sellers", to: "/#bestsellers" },
      { label: "Sign in", to: "/login" },
    ],
  },
  {
    title: "Care",
    links: [
      { label: "Contact Us", to: "/contact" },
      { label: "Shipping & Delivery", to: "/shipping-policy" },
      { label: "Returns & Refunds", to: "/returns-refunds" },
      { label: "Cancellation Policy", to: "/cancellation-policy" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export const Footer = () => {
  const [urls, setUrls] = useState({});
  useEffect(() => {
    fetchSocialLinks().then(setUrls).catch(() => {});
  }, []);
  return (
  <footer className="relative overflow-hidden border-t border-brand-gold/30 bg-brand-champagne" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 pb-10 pt-16 sm:px-6 lg:px-8 lg:pt-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <img
            src="/brand/heshaura-logo.png"
            alt="HESHAURA"
            className="h-[40px] w-auto max-w-full object-contain"
            data-testid="footer-logo"
          />
          <p className="mt-4 max-w-xs font-serif text-lg italic leading-relaxed text-brand-stone">{BRAND.tagline}</p>
          <div className="mt-8 flex flex-wrap gap-2.5" data-testid="footer-social">
            {SOCIAL_LINKS.map(({ key, label, icon }) => {
              const url = urls[key] || "";
              return url ? (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  title={label}
                  data-testid={`social-${key}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-brand-gold/40 text-brand-charcoal transition-[color,border-color,background-color] duration-300 hover:border-brand-gold hover:bg-brand-gold hover:text-brand-cream"
                >
                  <i className={`${icon} text-[15px]`} aria-hidden="true" />
                </a>
              ) : (
                <span
                  key={key}
                  aria-label={`${label} (coming soon)`}
                  title={`${label} — coming soon`}
                  data-testid={`social-${key}`}
                  className="flex h-10 w-10 cursor-default items-center justify-center rounded-full border border-brand-gold/20 text-brand-charcoal/30"
                >
                  <i className={`${icon} text-[15px]`} aria-hidden="true" />
                </span>
              );
            })}
          </div>
          <p className="mt-10 text-[11px] uppercase tracking-[0.2em] text-brand-stone">
            Handcrafted bracelets · Made in small batches in India
          </p>
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-brand-gold">{col.title}</p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.to.startsWith("#") ? (
                      <a href={l.to} className="text-sm text-brand-charcoal/75 transition-colors duration-200 hover:text-brand-gold">
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.to} className="text-sm text-brand-charcoal/75 transition-colors duration-200 hover:text-brand-gold">
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
        <img
          src="/brand/heshaura-logo.png"
          alt=""
          className="mx-auto h-28 w-auto max-w-full object-contain opacity-[0.10] sm:h-36 lg:h-48"
          data-testid="footer-wordmark"
        />
      </div>
      <div className="gold-rule" />
      <div className="flex flex-col items-center justify-between gap-3 pt-6 text-xs text-brand-stone sm:flex-row">
        <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
        <p className="font-serif text-sm italic">Timeless designs. A more radiant you.</p>
      </div>
    </div>
  </footer>
  );
};
